export default __webpack_public_path__ + "static/media/123-sleep-float-away.754d7014.jpeg";